import React, { type PropsWithChildren, useContext } from "react";
import { useAlbelliContext } from "../albelli/context";
import { useLogoUrlContext } from "../logo/context";
import { useWorkContext } from "../work/context";

export type ContentSourcesContext = {
  documentUrl?: string;
  albelliDocId?: string;
  logoUrl?: string;
  brandId?: string;
};

export const contentSourcesContext = React.createContext<
  ContentSourcesContext | undefined
>(undefined);

// TODO: remove if no props are needed in the end.
export type ContentSourcesContextProviderProps = {
  brandId?: string;
};

export function ContentSourcesContextProvider(
  props: PropsWithChildren<ContentSourcesContextProviderProps>,
) {
  const workContext = useWorkContext();
  const albelliContext = useAlbelliContext();
  const logoUrlContext = useLogoUrlContext();
  const documentUrl = workContext?.work?.design.designUrl;
  const albelliDocId = albelliContext?.albelliDocument?.documentId;
  const logoUrl = logoUrlContext?.logoUrl;
  const brandId = props.brandId;

  return (
    <contentSourcesContext.Provider
      value={{
        ...(documentUrl && { documentUrl }),
        ...(albelliDocId && { albelliDocId }),
        ...(logoUrl && { logoUrl }),
        ...(brandId && { brandId }),
      }}
    >
      {props.children}
    </contentSourcesContext.Provider>
  );
}

export function useContentSourcesContext() {
  const context = useContext(contentSourcesContext);
  if (!context) {
    throw new Error(
      "useContentSourcesContext must be used with ContentSourcesContextProvider",
    );
  }
  return context;
}
